import React, { useState } from 'react';
import PricingCard from '../../components/PricingCard/PricingCard';
import { Body1, Head2 } from '../../components/Typography/Typography';
import { rem } from 'polished';
import Box from '../../components/Box/Box';
import { PricingToggleSwitch } from './PricingToggleSwitch';
import WithSection from '../../components/WithSection/WithSection';
import { graphql } from 'gatsby';
import { gridGap } from '../../components/Grid/Grid';

const PricingCards = ({ data: { primary, items } }) => {
    const { subheading, heading } = primary;
    const plans = items.map((item) => item.plan_info.document.data);

    return (
        <Box gridColumn={{ _: '1/-1', lg: '2/-2', xl: '3/-3' }}>
            <Head2 textAlign="center" marginBottom={rem(20)}>
                {heading.text}
            </Head2>
            <Body1 textAlign="center" marginBottom={rem(40)}>
                {subheading}
            </Body1>
            <Box
                display="grid"
                justifyContent="center"
                gridGap={gridGap}
                gridTemplateColumns={{ _: '1fr', sm: '1fr 1fr' }}
            >
                {plans.map((plan) => (
                    <PricingCard key={plan.title} plan={plan} />
                ))}
            </Box>
        </Box>
    );
};

export const _ = graphql`
    fragment PRICING_SECTION on PrismicPricingDefault {
        primary {
            subheading
            heading {
                text
            }
        }
        items {
            plan_info {
                id
                document {
                    ... on PrismicPlanInfo {
                        id
                        data {
                            advanced_features {
                                icon {
                                    alt
                                    url
                                }
                                text
                                tooltip_text
                            }
                            advanced_features_is_beta
                            advanced_features_title
                            cta_link {
                                ...PRISMIC_LINK_FRAGMENT
                            }
                            cta_text
                            cta_tracking_event
                            description
                            features_title
                            is_selected
                            caption
                            price
                            border_color
                            title
                            features {
                                icon {
                                    alt
                                    url
                                }
                                text
                                tooltip_text
                            }
                        }
                    }
                }
            }
        }
    }
`;

export default WithSection(PricingCards);
